export default "__VITE_ASSET__DrRST_Gm__"